import React, {useState, useEffect} from 'react'
import { Image } from 'react-bootstrap'
import b01 from "../../../../assets/notarymeet/b01.png"

import '../notarymeet.css'


function B01() {

   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    const handleContextMenu = (e) => {
      e.preventDefault(); // Disable right-click
    };


  return (
    <div
    fluid 
    className='container-section' 
    style={{
      padding:0,
      backgroundColor:"#343434",
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: isSmallScreen ? 'auto' : '100vh'
      }}>
       <Image src={b01} alt='b01' width={100+"%"} draggable="false" onContextMenu={handleContextMenu}  height="auto" />
    </div>
    
     
    
  )
}

export default B01
